import {
  DeleteManyParams,
  DeleteManyResult,
  fetchUtils,
  HttpError,
  Identifier,
  RaRecord,
} from 'react-admin';
import type { AuthProvider } from './AuthProvider';
import {
  createReactAdminValidationError,
  getJsonApiErrorBody,
  getJsonApiErrorMessage,
  getJsonApiErrorStatus,
} from './JsonApiTypes';
import batch from './batch';

export default function deleteMany(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
  canAccess: typeof AuthProvider.canAccess = async () => true,
) {
  const executeBatch = batch(apiUrl, httpClient, canAccess);

  return async <T extends RaRecord<Identifier>>(
    resource: string,
    params: DeleteManyParams<T>,
  ): Promise<DeleteManyResult<T>> => {
    try {
      await executeBatch(
        params.ids.map((id) => ({
          op: 'remove',
          ref: { id: String(id), type: resource },
        })),
      );

      return { data: params.ids };
    } catch (error) {
      const validationErrors = createReactAdminValidationError(error as HttpError);
      throw new HttpError(
        getJsonApiErrorMessage(error as HttpError, 'Error deleting records'),
        getJsonApiErrorStatus(error as HttpError),
        {
          ...validationErrors,
          apiResponse: getJsonApiErrorBody(error),
        },
      );
    }
  };
}
